import { useRouterPath } from "@ambiguous/useRouterPath";
import { useEffect, useState } from "react";
export function getSearchParams(param) {
    const [result, setResult] = useState(searchParams(param));
    const [path] = useRouterPath();
    useEffect(() => {
        setResult(searchParams(param));
    }, [path]);
    return result;
}
function searchParams(param) {
    const searchParams = new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search);
    if (param) {
        return searchParams.get(param);
    }
    else {
        const variables = {};
        for (const [key, value] of searchParams.entries()) {
            variables[key] = value;
        }
        return variables;
    }
}
